class DiscountPromoList extends HTMLElement {
  constructor() {
    super();
    this.onCartChange = this.onCartChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.refresh();
    document.addEventListener('cart:item-added', this.onCartChange);
    document.addEventListener('cart:refresh-needed', this.onCartChange);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:item-added', this.onCartChange);
    document.removeEventListener('cart:refresh-needed', this.onCartChange);
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-discount-promo-copy-code]');
    if (!button) return;
    this.copyCode(button);
  }

  copyCode(button) {
    const code = button.dataset.discountPromoCopyCode;

    this.writeToClipboard(code)
      .then(() => this.showCopied(button))
      .catch((error) => console.error('discount-promos: failed to copy code', error));
  }

  writeToClipboard(text) {
    if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const succeeded = document.execCommand('copy');
        succeeded ? resolve() : reject(new Error('execCommand copy returned false'));
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  showCopied(button) {
    const label = button.querySelector('[data-discount-promo-copy-label]');
    if (!label) return;

    label.textContent = button.dataset.copiedText;
    window.clearTimeout(button._discountPromoResetTimeout);
    button._discountPromoResetTimeout = window.setTimeout(() => {
      label.textContent = button.dataset.defaultText;
    }, 2000);
  }

  onCartChange() {
    this.refresh();
  }

  refresh() {
    const cartUrl = (window.discountPromosRoutes && window.discountPromosRoutes.cartUrl) || '/cart';

    fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => this.applyState(cart))
      .catch((error) => console.error('discount-promos: failed to fetch cart', error));
  }

  applyState(cart) {
    const itemCount = cart.item_count || 0;
    const totalCents = cart.total_price || 0;

    this.querySelectorAll('[data-discount-promo-card]').forEach((card) => {
      const minQty = parseInt(card.dataset.minQty, 10) || 0;
      const minSubtotalCents = parseInt(card.dataset.minSubtotalCents, 10) || 0;
      const isActive = itemCount >= minQty && totalCents >= minSubtotalCents;

      card.classList.toggle('discount-promo-card--active', isActive);
      card.classList.toggle('discount-promo-card--inactive', !isActive);

      const copyButton = card.querySelector('[data-discount-promo-copy-code]');
      if (copyButton) copyButton.disabled = !isActive;
    });
  }
}

customElements.define('discount-promo-list', DiscountPromoList);
